import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import './Gallery.css';

const galleryItems = [
  {
    src: 'https://images.unsplash.com/photo-1519741497674-611481863552?w=800&q=80',
    category: 'Dasma',
    title: 'Dasma Elegante',
    span: 'tall',
  },
  {
    src: 'https://images.unsplash.com/photo-1470229722913-7c0e2dbbafd3?w=800&q=80',
    category: 'Evente',
    title: 'Koncert Nate',
    span: 'normal',
  },
  {
    src: 'https://images.unsplash.com/photo-1478146059778-26028b07395a?w=800&q=80',
    category: 'Dekorim',
    title: 'Dekor Lulesh',
    span: 'normal',
  },
  {
    src: 'https://images.unsplash.com/photo-1533174072545-7a4b6ad7a6c3?w=800&q=80',
    category: 'Efekte',
    title: 'Fishekzjarre',
    span: 'wide',
  },
  {
    src: 'https://images.unsplash.com/photo-1511285560929-80b456fea0bc?w=800&q=80',
    category: 'Dasma',
    title: 'Momenti i Pare',
    span: 'normal',
  },
  {
    src: 'https://images.unsplash.com/photo-1464366400600-7168b8af9bc3?w=800&q=80',
    category: 'Evente',
    title: 'Festa Private',
    span: 'tall',
  },
  {
    src: 'https://images.unsplash.com/photo-1505236858219-8359eb29e329?w=800&q=80',
    category: 'Dekorim',
    title: 'Setup Premium',
    span: 'normal',
  },
  {
    src: 'https://images.unsplash.com/photo-1510076857177-7470076d4098?w=800&q=80',
    category: 'Dasma',
    title: 'Ceremonia',
    span: 'normal',
  },
];

const categories = ['Te Gjitha', 'Dasma', 'Dekorim', 'Evente', 'Efekte'];

const Gallery = () => {
  const [activeCategory, setActiveCategory] = useState('Te Gjitha');
  const [lightbox, setLightbox] = useState(null);
  const [ref, inView] = useInView({ threshold: 0.1, triggerOnce: true });

  const filtered = activeCategory === 'Te Gjitha'
    ? galleryItems
    : galleryItems.filter((item) => item.category === activeCategory);

  return (
    <section className="gallery section-padding" id="gallery" ref={ref}>
      <div className="section-container">
        <motion.div
          className="gallery__header"
          initial={{ opacity: 0, y: 40 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
        >
          <span className="section-label">Galeria</span>
          <h2 className="section-title">
            Punet tona <em>flasin</em> per ne
          </h2>
          <p className="section-subtitle">
            Shikoni disa nga momentet me te bukura qe kemi krijuar per klientet tane.
          </p>
        </motion.div>

        {/* Filters */}
        <motion.div
          className="gallery__filters"
          initial={{ opacity: 0, y: 20 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ delay: 0.2, duration: 0.6 }}
        >
          {categories.map((cat) => (
            <button
              key={cat}
              className={`gallery__filter ${activeCategory === cat ? 'gallery__filter--active' : ''}`}
              onClick={() => setActiveCategory(cat)}
            >
              {cat}
            </button>
          ))}
        </motion.div>

        {/* Grid */}
        <motion.div className="gallery__grid" layout>
          <AnimatePresence mode="popLayout">
            {filtered.map((item, i) => (
              <motion.div
                key={item.src}
                className={`gallery__item gallery__item--${item.span}`}
                layout
                initial={{ opacity: 0, scale: 0.9 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.9 }}
                transition={{ duration: 0.5, delay: i * 0.05 }}
                onClick={() => setLightbox(item)}
              >
                <img src={item.src} alt={item.title} loading="lazy" />
                <div className="gallery__item-overlay">
                  <span className="gallery__item-category">{item.category}</span>
                  <h4 className="gallery__item-title">{item.title}</h4>
                  <div className="gallery__item-icon">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                      <path d="M15 3h6v6M14 10l7-7M9 21H3v-6M10 14l-7 7" />
                    </svg>
                  </div>
                </div>
              </motion.div>
            ))}
          </AnimatePresence>
        </motion.div>
      </div>

      {/* Lightbox */}
      <AnimatePresence>
        {lightbox && (
          <motion.div
            className="gallery__lightbox"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setLightbox(null)}
          >
            <motion.img
              src={lightbox.src}
              alt={lightbox.title}
              initial={{ scale: 0.8, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.8, opacity: 0 }}
              transition={{ duration: 0.3 }}
            />
            <button className="gallery__lightbox-close" onClick={() => setLightbox(null)}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                <path d="M18 6L6 18M6 6l12 12" />
              </svg>
            </button>
          </motion.div>
        )}
      </AnimatePresence>
    </section>
  );
};

export default Gallery;
